<template>
    <banner :bgImage="bannerInfo.file || bgImage" :title="bannerInfo.title" :subTitle="bannerInfo.desc"></banner>
    <div class="main-bg history-bg">
        <div class="wrap">
            <Ani>
                <div class="history-box color-f">
                    <div class="history">
                        <div class="history-list">
                            <swiper
                                :modules="[Pagination,EffectFade]"
                                effect="fade"
                                :fadeEffect="{crossFade: true}"
                                :simulateTouch="false"
                                :pagination="{ clickable: true }"
                                @swiper="setHisSwiper"
                            >
                                <swiper-slide v-for="(item, index) in way.dataList" :key="index">
                                    <div class="his-year font24 text-center">{{item.tabName}}<i></i></div>
                                    <h3 class="his-title font36 ellipsis text-center" v-if="locale=='zh-CN'">{{item.title}}</h3>
                                    <el-popover
                                        title=""
                                        :content="item.title"
                                        placement="top"
                                        v-else
                                    >
                                        <template #reference>
                                            <h3 class="his-title font36 ellipsis text-center">{{item.title}}</h3>
                                        </template>
                                    </el-popover>
                                    <div class="his-con font16">
                                        <el-scrollbar class="his-des">
                                            <p v-for="(child,childIndex) in item.descList" :key="childIndex">{{child}}</p>
                                        </el-scrollbar>
                                    </div>
                                </swiper-slide>
                            </swiper>
                        </div>
                    </div>
                </div>
                <el-scrollbar class="year-tab font24">
                    <ul class="year-list">
                        <li v-for="(item,index) in way.dataList" :key="index" :class="{ active: hisYear == item.tabName }" @mouseenter="changeYear(item.tabName,index)"><span>{{ item.tabName }}</span></li>
                    </ul>
                </el-scrollbar>
                <!-- <div class="year-tab font24">
                    <swiper 
                        :modules="[Thumbs]"
                        :slides-per-view="5"
                        :spaceBetween="10"
                        :freeMode= "true"
                        direction="vertical"
                        :observer="true"
                        :observeParents="true"
                        :watchSlidesVisibility = "true"
                        :watchSlidesProgress = "true"
                        @swiper="setTabSwiper"
                        :breakpoints="{
                            460: {
                                slidesPerView: 5,
                                spaceBetween: 10
                            },
                            640: {
                                slidesPerView: 5,
                                spaceBetween: 10
                            },
                            768: {
                                slidesPerView: 6,
                                spaceBetween: 20
                            },
                            991: {
                                slidesPerView: 7,
                                spaceBetween: 24
                            }
                        }"
                    >
                        <swiper-slide v-for="(item,index) in way.dataList" :key="index">
                            {{ item.tabName }}
                        </swiper-slide>
                    </swiper>
                </div> -->
            </Ani>
        </div>
    </div>
</template>
<script setup lang="ts">
    import { ref } from 'vue'
	import { Swiper, SwiperSlide } from 'swiper/vue';
    import { Autoplay, Pagination, Thumbs, EffectFade } from 'swiper/modules';
    import 'swiper/css'
    import 'swiper/css/autoplay';
    import 'swiper/css/thumbs';
    import 'swiper/css/effect-cube';
    import 'swiper/css/effect-fade';

    import useServerRequest from '@/composables/useServerRequest'
    import type { configParams, configResponse,bannerConfig } from '~/types'
    import { useI18n } from 'vue-i18n'
    import { handleApiResponse } from "@/utils/utils"
    import { useRoute } from 'vue-router'

    const config = useRuntimeConfig()
    const cmsurlStrategy = config?.public?.cmsStrategy

    // 2. 获取当前路由和语言
    const route = useRoute()
    const { locale } = useI18n()

    // 3. 初始化响应式数据
    const bgImage = ref<string>(staticURL('/banner/history-banner.webp'))
     const status = ref<number>(0)

    // 5. 配置信息
    //其他信息
    const seo = ref<configResponse['pageValue']['seo']>({
    title: '',
    keywords: '',
    desc: ''
})
    const bannerInfo = ref<bannerConfig>({})
    const way = ref<configResponse['pageValue']['way']>({
        dataList:[]
    })
    const infoParams = ref<configParams>({
        pageCode: "MOJI_WAY"
    })
    const getInfo = async () => {
        try {
            const { data } = await useServerRequest<configResponse>(
                'history-info',
                `${cmsurlStrategy}/getPageConfig`,
                { method: 'GET', params: infoParams.value, language: locale.value }
            )
            const res = data?.value
            const result = handleApiResponse(res)
            if (!result.success) {
                status.value = result.status
                return
            }
            const getInfoData = data?.value?.data?.pageValue
            seo.value = getInfoData?.seo
            console.log(data)
            way.value = getInfoData?.way
            hisYear.value = getInfoData?.way?.dataList?.[0].tabName
            bannerInfo.value = getInfoData?.banner?.[0] || {}; // 链式判断 + 默认值
            
        } catch (error) {
            status.value = 2
        }
    }
    getInfo()
    useHead({
        title: () => seo?.value?.title,
        meta: [
            { rel: 'prefetch', name: 'Keywords', content: `${seo?.value?.keywords || ''}` },
            { rel: 'prefetch', name: 'Description', content: `${seo?.value.desc || ''}` },
        ],
    })
    
    const tabSwiper = ref(null);
    const setTabSwiper = (swiper: null) => {
        tabSwiper.value = swiper;
    };

    const hisSwiper = ref(null);
    const setHisSwiper = (swiper: null) => {
        hisSwiper.value = swiper;
    };
    const hisYear = ref(null);
    const changeYear = (year: string, index:number)=>{
        console.log(year)
        hisYear.value = year;
        if (hisSwiper.value) {
            hisSwiper.value.slideToLoop(index, 500, false)
        }
    }

    
</script>
<style scoped lang="scss">
@use '@/assets/css/about.scss';
</style>